import { Button } from '@workspace/ui/components/Button';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '~/components/Icon/Icon';
import type { Product } from '~/stores/CategoriesStore';

import { SearchResultItemDropdown } from './SearchResultItemDropdown';

interface SearchResultsSectionProps
  extends Omit<React.ComponentPropsWithoutRef<'div'>, 'children'> {
  searchResults: Product[] | null;
  handleCloseDropdown: (
    e?: React.MouseEvent<HTMLButtonElement | HTMLDivElement>,
  ) => void;
  handleStartSearch?: () => void;
  inverse?: boolean;
}

export const SearchResultsSection = observer<SearchResultsSectionProps>(
  ({
    searchResults,
    handleCloseDropdown,
    handleStartSearch,
    inverse = false,
    className,
    ...props
  }) => {
    const { t } = useTranslation();

    if (!searchResults || searchResults.length === 0) {
      return null;
    }

    return (
      <div {...props} className={cn('flex flex-col gap-2', className)}>
        <div className="flex flex-col gap-1">
          {searchResults.map((product) => (
            <SearchResultItemDropdown
              key={product.id}
              product={product}
              onClose={handleCloseDropdown}
              inverse={inverse}
            />
          ))}
        </div>
        {handleStartSearch && (
          <Button
            variant={inverse ? 'shadowXS' : 'brand'}
            size="lg"
            endIcon={
              <Icon type="chevron-3.1" size={11} className="rotate-180" />
            }
            className={cn(
              'mx-auto mt-2 mb-6 w-[163px] px-5 py-[14px]',
              inverse ? 'text-text-primary!' : 'text-text-inverse-primary!',
            )}
            onClick={(e) => {
              e.stopPropagation();
              handleStartSearch();
            }}
          >
            {t('header:seeAllResults')}
          </Button>
        )}
      </div>
    );
  },
);
